export default class TokenExpiredError extends Error {
  constructor() {
    super('REFRESH TOKEN EXPIRED');
    this.name = 'TokenExpiredError';
  }
}